export default __webpack_public_path__ + "static/better_future_through_code-1c110fefc8201c85ac14e0653109a302.jpg";